// extracted by mini-css-extract-plugin
export default {"board":"castle-select-modal_board__Wo47y","option":"castle-select-modal_option__8lmxy"};